var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"Banner"},[(_vm.banner)?_c('img',{attrs:{"src":_vm.banner,"alt":""}}):_vm._e(),(!_vm.banner)?_c('div',{staticClass:"noBanner"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }